import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableReCaptchaForForgetPassword',
  initialState: false,
  reducers: {
    setEnableReCaptchaForForgetPassword(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableReCaptchaForForgetPassword } = slice.actions;

export default slice.reducer;
